import React, { Component, Ref } from 'react'
import { Container, withPixiApp } from "@inlet/react-pixi";
import UIManager from "../../core/components/ui/UiBuilder";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { isMobile } from "react-device-detect";
import { Ilanguage } from "../../core/interface/Icommon";
import { _ReactPixi } from "@inlet/react-pixi";
import { alllanguage } from "../../data/lang/index"
import { CURRENCY } from "../../core/utills";
import withWinPanleConfiguration from "./configuration/withwinpanelconfiguration";
//import GridcontainerAL from "../gridcontainerAL/gridContainerAL";
import { Tween } from "../../core/components/effect/tween";
import WinDropComponent from "../windropcomponent/windrop";
import WinPanelListComponent from "../winpanelList/winPanelList";
import { drop } from 'lodash';
import { actions as winDropActions } from '../../gamereducer/winDropReducer'
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { TIMER } from "../../core/utills";

interface IStore {
    [x: string]: any;
}


interface IProps {
    [x: string]: any;
}

interface IStateToProps {

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class WinPanelComponent extends Component<IProps, IState> {
    private app: PIXI.Application;
    protected winPanelContainer: _ReactPixi.IContainer | Ref<any>;
    protected displayUI: any;
    protected dropComponentMain: any;
    protected WinPanelMainContainer: any;
    protected xAxis: number = -30;
    protected yAxis: number = 878;
    protected tempCount: number = 0;
    protected ui_mode: string;
    protected windroplist: Array<any>
    protected tempArrayForStoreElem: Array<any>

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.winPanelContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this))
        this.windroplist = []
        this.tempArrayForStoreElem = []
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    addMaskToWinDropContainer() {
        // this.dropComponentMain = UIManager.getRef("DropComponentMain")
        // //this.dropComponentMain.mask = null;

        // //this.dropComponentMain && this.dropComponentMain.removeChildByName("maskGraphic");
        // const thing = new PIXI.Graphics();
        // thing.beginFill(0xDE3249);
        // thing.drawRect(0, 100, 300, 490);
        // thing.endFill();
        // thing.name = "maskGraphic"
        // //this.dropComponentMain && this.dropComponentMain.addChild(thing);
        // thing.x = 0;
        // thing.y = 0;
        // this.dropComponentMain && (this.dropComponentMain.mask = thing);




        // this.WinPanelMainContainer = UIManager.getRef("WinPanelMainContainer")
        // const thing2 = new PIXI.Graphics();
        // thing2.beginFill(0xDE3249);
        // thing2.drawRect(0, 100, 300, 490);
        // thing2.endFill();
        // thing2.name = "maskGraphic2"
        // //this.WinPanelMainContainer.mask = null;
        // //this.WinPanelMainContainer.children.pop()
        // //this.WinPanelMainContainer && this.WinPanelMainContainer.addChild(thing2);
        // thing2.x = 0;
        // thing2.y = 0;
        // this.WinPanelMainContainer && (this.WinPanelMainContainer.mask = thing2);



        this.WinPanelMainContainer = UIManager.getRef("winPanelContainer")
        const thing2 = new PIXI.Graphics();
        thing2.beginFill(0xDE3249);
        thing2.drawRect(70, 540, 300, 300);
        thing2.endFill();
        thing2.name = "maskGraphic2"
        //this.WinPanelMainContainer.mask = null;
        //this.WinPanelMainContainer.children.pop()
        this.WinPanelMainContainer && this.WinPanelMainContainer.addChild(thing2);
        thing2.x = 0;
        thing2.y = 0;
        this.WinPanelMainContainer && (this.WinPanelMainContainer.mask = thing2);


    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        //this.layoutChange(this.props.layoutMode)
    }

    componentDidMount() {
        this.addMaskToWinDropContainer();
        this.coOrdinatesChanges();
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.coOrdinatesChanges();
            return false;
        }
        if (nextProps.isRequestSent && nextProps.isRequestSent != this.props.isRequestSent

        ) {
            // setTimeout(() => {

            //     this.windroplist.length = 0;
            // }, 300)
            let droppingElementList = UIManager.getRef("WinPanelMainContainer").children;
            if (droppingElementList.length === 0) {
                this.windroplist.length = 0;
            }
            return false;
        }
        if (nextProps.blastStart !== this.props.blastStart
            || nextProps.spinStart !== this.props.spinStart) {
            if (nextProps.spinStart && nextProps.spinStart !== this.props.spinStart) {
                // this.windroplist.length = 0;
                this.tempCount = 0
                this.tempArrayForStoreElem = [];
                let droppingElementList = UIManager.getRef("WinPanelMainContainer").children;
                for (let i = 0; i < droppingElementList.length; i++) {
                    if (!droppingElementList[i].justCreated) {
                        droppingElementList[i].justCreated = false;
                        //console.log("winPanelContainer :: POGO :: TWEENSTART", this.windroplist[i])
                        new Tween(
                            [droppingElementList[i]],
                            {
                                ['y']: { start: droppingElementList[i].y, end: 480 }
                            },
                            0.3,
                            "easeOutBounce",
                            false, null, null, null, null, false, onchange, (e: any) => {
                                e.dispose();
                                UIManager.getRef("WinPanelMainContainer").removeChildAt(0)
                                //this.addMaskToWinDropContainer();
                            }
                        );
                    }


                }

            }
            if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {

                let timer = TIMER.TimerManager.createTimer(1500);
                timer.on('end', () => {
                    let droppingElementList = UIManager.getRef("WinPanelMainContainer").children;

                    for (let i = 0; i < droppingElementList.length; i++) {
                        if (droppingElementList[i].justCreated) {
                            this.tempArrayForStoreElem.push(droppingElementList[i])
                            droppingElementList[i].justCreated = false
                        }
                    }

                    let index_start = 0;
                    let delay_fornextcascade = 1000;

                    let oldArray: any = [];
                    let newArray: any = [];
                    for (let i = 0; i < this.tempArrayForStoreElem.length; i++) {
                        if (this.tempArrayForStoreElem[i].movestart && this.tempArrayForStoreElem[i].movecomplete) {
                            this.tempArrayForStoreElem[i].visible = false;
                            oldArray.push(this.tempArrayForStoreElem[i]);
                        } else {
                            newArray.push(this.tempArrayForStoreElem[i]);
                        }
                    }

                    for (let j = 0; j < newArray.length; j++) {


                        if (j > 4) {

                            let timer_gap = TIMER.TimerManager.createTimer(1 + delay_fornextcascade * Math.floor(j / 5));
                            timer_gap.on('end', () => {
                                for (let i = 0; i < newArray.length; i++) {
                                    if (newArray[i].movestart && newArray[i].movecomplete) {
                                        newArray[i].visible = false;
                                    }
                                }
                                if (j % 5 == 0) {
                                    index_start = 0;
                                }
                                new Tween(
                                    [newArray[j]],
                                    {
                                        ['y']: { start: newArray[j].y, end: newArray[j].y + 180 + 60 * index_start }
                                    },
                                    0.3,
                                    "easeOutCirc",
                                    false, null, null, null, null, false, onchange, (e: any) => {
                                        e.dispose();
                                        newArray[j].movestart = true;
                                        newArray[j].movecomplete = true;
                                    }
                                );
                                index_start++

                            });
                            timer_gap.start();

                        } else {
                            if (j % 5 == 0) {
                                index_start = 0;
                            }
                            new Tween(
                                [newArray[j]],
                                {
                                    ['y']: { start: newArray[j].y, end: newArray[j].y + 180 + 60 * index_start }
                                },
                                0.3,
                                "easeOutCirc",
                                false, null, null, null, null, false, onchange, (e: any) => {
                                    e.dispose();
                                    newArray[j].movestart = true;
                                    newArray[j].movecomplete = true;
                                }
                            );
                            index_start++
                        }
                        newArray[j].movestart = true;
                        newArray[j].movecomplete = false;

                    }

                });
                timer.start();


                return true
            }
            return false
        }
        return true
    }
    shouldComponentUpdate_temp(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.blastStart !== this.props.blastStart
            // || nextProps.winDropList !== this.props.winDropList
            || nextProps.layoutMode !== this.props.layoutMode
            || nextProps.spinStart !== this.props.spinStart

        ) {
            if (nextProps.spinStart && nextProps.spinStart !== this.props.spinStart) {
                // if (UIManager.getRef("WinPanelMainContainer").children.length) {
                //     UIManager.getRef("WinPanelMainContainer").removeChildAt(0)
                // }
                // let distroyComponentList = UIManager.getRef("WinPanelMainContainer").children;

                // let i: number = 0;
                // while (i < distroyComponentList.length) {
                //     UIManager.getRef("WinPanelMainContainer").removeChildAt(0);
                // }
                // this.props.setWinDropList([]);
            }
            if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {
                let createdComponentList = UIManager.getRef("winPanelListContainer").children;

                let i: number = 0;
                while (i < createdComponentList.length) {
                    // let obj = createdComponentList[i]

                    // obj = createdComponentList[i]
                    createdComponentList[i].justCreated = false;
                    // obj.key = Math.random() + "key"
                    // obj.id = Math.random() + "id"
                    // obj.name = Math.random() + "name"


                    UIManager.getRef("WinPanelMainContainer").addChild(createdComponentList[i]);
                }

            }
            return false;

        }
        return true
    }
    shouldComponentUpdate_(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.spinStart !== this.props.spinStart
            || nextProps.startDropCompleteCount !== this.props.startDropCompleteCount
            || nextProps.layoutMode !== this.props.layoutMode

        ) {
            if (nextProps.startDropCompleteCount == 7) {
                //this.props.blastStart();
            }
            if (nextProps.spinStart && nextProps.spinStart !== this.props.spinStart) {
                let countTween = 0;
                for (let i = 0; i < this.windroplist.length; i++) {
                    if (this.windroplist[i].children.length) {
                        //console.log("winPanelContainer :: POGO :: TWEENSTART", this.windroplist[i])
                        new Tween(
                            [this.windroplist[i]],
                            {
                                ['y']: { start: this.windroplist[i].y, end: 480 }
                            },
                            0.3,
                            "easeOutBounce",
                            false, null, null, null, null, false, onchange, (e: any) => {
                                countTween++;
                                e.dispose();
                                if (UIManager.getRef("DropComponentMain").children.length) {
                                    UIManager.getRef("DropComponentMain").removeChildAt(0)
                                }
                                if (countTween === this.windroplist.length) {
                                    //console.log("winPanelContainer :: POGO ::", UIManager.getRef("DropComponentMain"))
                                    //this.windroplist.length = 0;
                                    //this.props.setWinDropList([]);
                                    //this.props.resetWinDropState();
                                    //this.addMaskToWinDropContainer();
                                }

                            }
                        );
                    }


                }
            }

            if (nextProps.layoutMode !== this.props.layoutMode) {
                // this.layoutChange(nextProps.layoutMode)
                this.coOrdinatesChanges();
            }
            return false;
        }

        return true;
    }
    coOrdinatesChanges() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("winPanelContainer").x = this.xAxis;
            UIManager.getRef("winPanelContainer").y = this.yAxis;
            UIManager.getRef("winPanelContainer").scale.set(0.9);
        }
        else {
            UIManager.getRef("winPanelContainer").x = 0;
            UIManager.getRef("winPanelContainer").y = 0;
            UIManager.getRef("winPanelContainer").scale.set(1);
        }
    }
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name)
            }
        });

    }
    /* Handle Event from Below funcitons */
    handleEvent = (e: any) => {

    }

    render() {

        //-41,-794
        const drop_component = [];
        let xAxis = 0, yAxis = 0;
        if (isMobile && window.innerWidth < window.innerHeight) {
            xAxis = this.xAxis;
            yAxis = this.yAxis;
        }
        // for (var i = 0; i < this.props.winDropList.length; i++) {

        //     let PROPS_TO_SEND_WinDropComponent = {
        //         key: "drop_component_" + i,
        //         count: i,
        //         name: "drop_component_" + i,
        //         langObj: this.props.langObj,
        //         x: 0,
        //         y: 0,
        //         canvasApp: this.app,
        //         windroplistPass: this.windroplist,
        //     }

        //     drop_component.push(<WinDropComponent {...PROPS_TO_SEND_WinDropComponent}
        //     />);
        // }

        let PROPS_TO_SEND_WinPanelListComponent = {

            langObj: this.props.langObj,
            x: 0,
            y: 0,
            canvasApp: this.app,
            listForStaticSymbol: this.windroplist
        }

        return (
            <UIManager id={"winPanelContainer"} name={"winPanelContainer"} x={xAxis} y={yAxis} type={"Container"} ref={i => this.winPanelContainer = i} >
                {/* {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-winPanel-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent.bind(this)} />)
                } */}

                <UIManager id={"WinPanelMainContainer"} ref={i => this.WinPanelMainContainer = i} name={"WinPanelMainContainer"} type={"Container"} x={68} y={365}>
                    {

                        this.windroplist && this.windroplist.map((i: any) => i)

                    }
                </UIManager>
                <UIManager id={"DropComponentMain"} ref={i => this.dropComponentMain = i} name={"DropComponentMain"} type={"Container"} x={68} y={365}>
                    {/* {drop_component} */}


                    {<WinPanelListComponent {...PROPS_TO_SEND_WinPanelListComponent} ></WinPanelListComponent>}
                </UIManager>

            </UIManager>
        );
    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'asyncServerAction' | 'winDropState' | 'gridsState' | 'applicationState'>): IStateToProps =>
    ({
        // winDropList: state.winDropState.winDropList,
        spinStart: state.gridsState.spinStart,
        blastStart: state.gridsState.blastStart,

        isRequestSent: state.asyncServerAction.isRequestSent,
        // startDropCompleteCount: state.gridsState.startDropCompleteCount,
        layoutMode: state.applicationState.layoutMode,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        // resetWinDropState: (): any => dispatch(winDropActions.resetWinDropState()),
        setWinDropList: (dropList: any): any => dispatch(winDropActions.setWinDropList(dropList)),
        // blastStart: (): any => dispatch(gridsActions.blastStart()),
        // setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(withWinPanleConfiguration(WinPanelComponent)));